'use strict';
import util from './util';
import customModal  from './modal';
SessionAttributes = window.SessionAttributes;

/**
 * @function captcha    Used to display/control the scrim containing the simulated captcha code
 **/
export default function () {
	/**
	 * if the session.privacy.ratelimited element is present then show the notification
	 * NOTE: You will probably want to replace this with a call to an actual CAPTCHA system to replace the simple one here
	 */
	if (SessionAttributes.SHOW_CAPTCHA) {
		customModal.createCustomModal('login-captcha', '#modal-custom-placeholder');
		$('.login-captcha .modal-body').html('<h1>' + Resources.ARE_YOU_HUMAN + '</h1><button class="primary large">' + Resources.OK + '</button>');
		$('.login-captcha button').on('click', function() {
			var url = util.appendParamsToUrl(Urls.rateLimiterReset, {format: 'ajax'});
			$.ajax({
				url: url
			});
			$('.login-captcha .modal-close').trigger('click');
		});
	}
};
